import { BattleState } from "../../State/State";
import { BattleStages } from "./types";

export const calculateBattleStage = (battleState: BattleState | null) => {
  if (!battleState) return BattleStages.INITIALISING;

  if (!battleState.attacking?.main)
    return BattleStages.CHOOSE_MAIN_ATTACKING_CARD;

  if (!battleState.attacking?.hand) return BattleStages.AWAITING_HAND;

  if (!battleState.attacking?.secondary)
    return BattleStages.SELECT_SECONDARY_SIDE_CARD;

  if (!battleState.attacking?.third) return BattleStages.SELECT_THIRD_SIDE_CARD;

  if (battleState.result === null) return BattleStages.AWAITING_RESULT;

  if (battleState.result === "win") return BattleStages.WIN;
  if (battleState.result === "lose") return BattleStages.LOSE;

  return BattleStages.INITIALISING;
};
